var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-file-toolbar-menu',{staticClass:"custom-toolbar",attrs:{"content":_vm.menu}}),_c('div',{staticClass:"scrollable"},[_c('div',{ref:"editor"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }